"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuthentication = void 0;
const cookies_1 = require("root/src/client/v2/browser/helpers/cookies");
const useAuthentication = () => {
    const accessToken = (0, cookies_1.getCookie)('accessToken');
    const refreshToken = (0, cookies_1.getCookie)('refreshToken');
    const userId = (0, cookies_1.getCookie)('userId');
    const email = (0, cookies_1.getCookie)('email');
    const groups = (0, cookies_1.getCookie)('groups');
    if (typeof accessToken !== 'string'
        || typeof email !== 'string'
        || typeof userId !== 'string'
        || typeof groups !== 'string') {
        return { authentication: undefined };
    }
    const groupsParsed = JSON.parse(groups);
    return {
        authentication: {
            accessToken,
            email,
            userId,
            groups: groupsParsed,
            refreshToken,
        },
    };
};
exports.useAuthentication = useAuthentication;
